/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_2fa_OtpauthInputs */

const cs_settings_profile_2fa_otpauth = /** @type {(inputs: Settings_Profile_2fa_OtpauthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL pro autentikátor`)
};

const en_settings_profile_2fa_otpauth = /** @type {(inputs: Settings_Profile_2fa_OtpauthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authenticator URL`)
};

/**
* | output |
* | --- |
* | "Authenticator URL" |
*
* @param {Settings_Profile_2fa_OtpauthInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_2fa_otpauth = /** @type {((inputs?: Settings_Profile_2fa_OtpauthInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_2fa_OtpauthInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_2fa_otpauth(inputs)
	return cs_settings_profile_2fa_otpauth(inputs)
});